$(document).ready(function () {
    $('.show-gallery').click(function (event) {
        event.preventDefault();
        $('.show-gallery').lightGallery({
            dynamic: true,
            dynamicEl: images,
            download: false,
            thumbnail: false,
            share: false,
            zoon: false,
            hash: false,
            pager: $(window).width() >= 768 ? true : false,
            youtubePlayerParams: {
                modestbranding: 1,
                showinfo: 0,
                rel: 0,
                controls: 0
            },
            loadYoutubeThumbnail: true
        });
        return false;
    });
});


// WEBPACK FOOTER //
// ./js/pages/single.js